export default __webpack_public_path__ + "static/media/CityLights03.589c8880.jpg";